export default {"src":"/_next/static/media/phone-shape.533da38a.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};